"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMarkDownEditorDialogVM = exports.MarkDownEditorDialogPM = void 0;
const Entities_1 = require("../../Entities");
class MarkDownEditorDialogPM {
    updateAlertObserver(markDownEditor) {
        if (markDownEditor === this.observingMarkDownEditor)
            return;
        if (this.observingMarkDownEditor !== null) {
            this.observingMarkDownEditor.removeObserver(this.doUpdateView);
        }
        if (markDownEditor !== null) {
            markDownEditor.addObserver(this.doUpdateView);
        }
        this.observingMarkDownEditor = markDownEditor;
    }
    vmHasChanged(vm) {
        if (this.lastVM === undefined)
            return true;
        if (vm.initialText === this.lastVM.initialText) {
            return false;
        }
        return true;
    }
    constructor(repo, updateView) {
        this.repo = repo;
        this.updateView = updateView;
        this.observingMarkDownEditor = null;
        this.doUpdateView = () => {
            let vm = {
                initialText: '',
                confirm: (text) => {
                    console.warn('[MarkDownEditorDialogVM.confirm] empty VM!');
                },
            };
            if (this.repo.activeDialog && this.repo.activeDialog.type === Entities_1.markDownEditorDialogType) {
                const markDownEditorDialog = this.repo.activeDialog;
                this.updateAlertObserver(markDownEditorDialog);
                vm = {
                    confirm: markDownEditorDialog.confirm,
                    initialText: markDownEditorDialog.initialText,
                };
            }
            else {
                this.updateAlertObserver(null);
            }
            if (!this.vmHasChanged(vm))
                return;
            this.updateView(vm);
            this.lastVM = vm;
        };
        this.dispose = () => {
            this.repo.removeObserver(this.doUpdateView);
            if (this.observingMarkDownEditor) {
                this.observingMarkDownEditor.removeObserver(this.doUpdateView);
            }
        };
        repo.addObserver(this.doUpdateView);
        this.doUpdateView();
    }
}
exports.MarkDownEditorDialogPM = MarkDownEditorDialogPM;
exports.defaultMarkDownEditorDialogVM = {
    initialText: '',
    confirm: (text) => {
        console.warn('[MarkDownEditorDialogVM.confirm] default VM!');
    },
};
